import {
	createResource,
	useResource,
	type RouteResourceError,
} from '@atlassian/react-resource-router';
import { fetchConfiguration } from './services/configuration/index.tsx';
import type { ConfigurationResource, Field } from './types.tsx';

const RESOURCE_KEY = 'BUSINESS_CONFIGURATION';

/**
 * @deprecated delete entire package when cleaning up sv-151_migrate_start_date_field_fetching_to_relay
 */
export const configurationResource = createResource<ConfigurationResource>({
	type: RESOURCE_KEY,
	getKey: () => RESOURCE_KEY,
	getData: (_, { tenantContext: { cloudId } }) => fetchConfiguration(cloudId),
	maxAge: Infinity,
});

export const useConfigurationResource = () => useResource(configurationResource);

/**
 * @deprecated delete entire package when cleaning up sv-151_migrate_start_date_field_fetching_to_relay
 */
export const useStartDateField = (): {
	data: Field | null;
	loading: boolean;
	error: RouteResourceError | null;
} => {
	const { data, loading, error } = useConfigurationResource();

	return { data: data?.startDateField ?? null, loading, error };
};
